import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * This directive must be used to wrap content to be displayed in the Tab
 * */
@Directive({
  selector: '[mbsTabsetContent]'
})
export class TabsetContentDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
}
